import { apiUrl, authHeaders } from './auth';

export const fetchMedicalCenters = async ({
  page = 1,
  verificationStatus = '',
  status = '',
  name = '',
  state = '',
}) => {
  const headers = authHeaders();
  const url = `${apiUrl}/admin/medicalCenters?page=${page}&verification_status=${verificationStatus}&status=${status}&name=${name}&state=${state}`;
  const resp = await fetch(url, {
    method: 'get',
    headers,
  });
  if (!resp.ok) {
    throw new Error('Error fetching medical centers');
  }
  const json = await resp.json();
  return json;
};

export const fetchMedicalCenter = async (id) => {
  const headers = authHeaders();
  const url = apiUrl + '/admin/medicalCenters/' + id;
  const resp = await fetch(url, {
    method: 'get',
    headers,
  });
  const json = await resp.json();
  console.log('json: ', json);
  return json;
};

export const approveMedicalCenter = async (
  id: number,
  approved_by_person_id: number
) => {
  const headers = authHeaders();
  const url = `${apiUrl}/admin/medicalCenters/${id}/approve`;

  const resp = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify({ approved_by_person_id }),
  });
  if (!resp.ok) {
    throw new Error('Error fetching medical centers');
  }
  const json = await resp.json();
  return json;
};

export const updateMedicalCenter = async (id: number, data: any) => {
  const headers = authHeaders();
  const url = `${apiUrl}/admin/medicalCenters/${id}`;
  const res = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Error updating medical center');
  const json = await res.json();
  return json;
};

export const fetchMedicalProfessionalsForMedicalCenter = async (
  id: number,
  page = 1
) => {
  const headers = authHeaders();
  const url = `${apiUrl}/admin/medicalCenters/${id}/medicalProfessionals?page=${page}`;
  const resp = await fetch(url, {
    method: 'get',
    headers,
  });
  const json = await resp.json();
  return json;
};

export const fetchMedicalCenterPatients = async (id: number, page: number) => {
  const headers = authHeaders();
  const url = `${apiUrl}/admin/medicalCenters/${id}/patients?page=${page}`;
  const resp = await fetch(url, {
    method: 'get',
    headers,
  });
  const json = await resp.json();
  return json;
};

export const fetchUSStates = async () => {
  const headers = authHeaders();
  const url = `${apiUrl}/admin/states`;
  const resp = await fetch(url, {
    method: 'get',
    headers,
  });
  const json = await resp.json();
  return json;
};

export interface MedicalCenterPayload {
  name: string;
  city?: string;
  location?: string;
  zipcode?: string;
  url?: string;
  npi_num?: string;
}

export const createMedicalCenter = async (data: MedicalCenterPayload) => {
  const headers = authHeaders();
  const url = `${apiUrl}/admin/medicalCenters/create`;
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(data),
  });
  if (!resp.ok) {
    throw new Error('Error creating medical center');
  }
  const json = await resp.json();
  return json;
};
